/**
 * @flow
 * @relayHash 6ab9e63b7cd34fe3cc9d5b2cbed8190e
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type getEventQueryVariables = {|
  id: string
|};
export type getEventQueryResponse = {|
  +hyevent: {|
    +approverName: ?string,
    +inviteScheduledAt: ?any,
    +approvedAt: ?any,
    +disapprovedAt: ?any,
    +id: string,
    +title: string,
    +maxNoOfGuests: number,
    +additionalGuestAllowed: boolean,
    +maxAdditionalGuests: ?number,
    +ctaText: string,
    +disapproveReason: ?string,
    +messageTitle: string,
    +message: string,
    +address: string,
    +placeName: string,
    +status: string,
    +propertyId: string,
    +startAt: any,
    +endAt: any,
    +publishAt: ?any,
    +cancelReason: ?string,
    +rsvpedCount: number,
    +landingPageHtml: ?string,
    +invitedGroups: ?string,
    +confirmPageHtml: ?string,
    +confirmSmsBody: ?string,
    +flyerHtml: ?string,
    +waitlistedPageHtml: ?string,
    +cancelRsvpPageHtml: ?string,
    +removeFromWaitlistPageHtml: ?string,
    +inviteEmailCampaignId: ?string,
    +campaignTested: ?boolean,
    +image: {|
      +id: string,
      +fileType: string,
      +fileSize: number,
      +fileUrl: string,
      +dimension: ?string,
      +thumbnailUrl: ?string,
    |},
    +document: ?{|
      +createdAt: any,
      +dimension: ?string,
      +fileSize: number,
      +fileType: string,
      +fileUrl: string,
      +id: string,
      +name: string,
      +thumbnailUrl: ?string,
    |},
    +eventType: string,
    +zoomLink: string,
    +meetingId: string,
    +passcode: string,
    +smsEnabled: ?boolean,
    +displayTime: ?string,
    +leadFields: ?$ReadOnlyArray<string>,
    +rsvpFormHeader: ?string,
    +thankYouEmailHour: ?number,
    +enableThankYouEmail: ?boolean,
    +enableCancelEmail: ?boolean,
    +enableInviteEmail: ?boolean,
    +enableMorningReminderEmail: ?boolean,
    +enableNightReminderEmail: ?boolean,
    +enableRescheduleEmail: ?boolean,
    +enableRsvpCancelledEmail: ?boolean,
    +enableRsvpedEmail: ?boolean,
    +enableWaitlistOpeningEmail: ?boolean,
    +enableWaitlistedEmail: ?boolean,
    +emailList: ?any,
    +recurringEventType: ?string,
    +repeatType: ?string,
    +recurrenceType: ?string,
    +recurrenceEndDate: ?any,
    +recurringDaysList: ?string,
  |}
|};
export type getEventQuery = {|
  variables: getEventQueryVariables,
  response: getEventQueryResponse,
|};
*/


/*
query getEventQuery(
  $id: ID!
) {
  hyevent(id: $id) {
    approverName
    inviteScheduledAt
    approvedAt
    disapprovedAt
    id
    title
    maxNoOfGuests
    additionalGuestAllowed
    maxAdditionalGuests
    ctaText
    disapproveReason
    messageTitle
    message
    address
    placeName
    status
    propertyId
    startAt
    endAt
    publishAt
    cancelReason
    rsvpedCount
    landingPageHtml
    invitedGroups
    confirmPageHtml
    confirmSmsBody
    flyerHtml
    waitlistedPageHtml
    cancelRsvpPageHtml
    removeFromWaitlistPageHtml
    inviteEmailCampaignId
    campaignTested
    image {
      id
      fileType
      fileSize
      fileUrl
      dimension
      thumbnailUrl
    }
    document {
      createdAt
      dimension
      fileSize
      fileType
      fileUrl
      id
      name
      thumbnailUrl
    }
    eventType
    zoomLink
    meetingId
    passcode
    smsEnabled
    displayTime
    leadFields
    rsvpFormHeader
    thankYouEmailHour
    enableThankYouEmail
    enableCancelEmail
    enableInviteEmail
    enableMorningReminderEmail
    enableNightReminderEmail
    enableRescheduleEmail
    enableRsvpCancelledEmail
    enableRsvpedEmail
    enableWaitlistOpeningEmail
    enableWaitlistedEmail
    emailList
    recurringEventType
    repeatType
    recurrenceType
    recurrenceEndDate
    recurringDaysList
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "id",
    "type": "ID!",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "fileType",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "fileSize",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "fileUrl",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "dimension",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "thumbnailUrl",
  "args": null,
  "storageKey": null
},
v7 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "hyevent",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "Hyevent",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "approverName",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "inviteScheduledAt",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "approvedAt",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "disapprovedAt",
        "args": null,
        "storageKey": null
      },
      (v1/*: any*/),
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "title",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "maxNoOfGuests",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "additionalGuestAllowed",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "maxAdditionalGuests",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "ctaText",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "disapproveReason",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "messageTitle",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "message",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "address",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "placeName",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "status",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "propertyId",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "startAt",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "endAt",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "publishAt",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "cancelReason",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "rsvpedCount",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "landingPageHtml",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "invitedGroups",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "confirmPageHtml",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "confirmSmsBody",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "flyerHtml",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "waitlistedPageHtml",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "cancelRsvpPageHtml",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "removeFromWaitlistPageHtml",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "inviteEmailCampaignId",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "campaignTested",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "image",
        "storageKey": null,
        "args": null,
        "concreteType": "Asset",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/)
        ]
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "document",
        "storageKey": null,
        "args": null,
        "concreteType": "Asset",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "createdAt",
            "args": null,
            "storageKey": null
          },
          (v5/*: any*/),
          (v3/*: any*/),
          (v2/*: any*/),
          (v4/*: any*/),
          (v1/*: any*/),
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "name",
            "args": null,
            "storageKey": null
          },
          (v6/*: any*/)
        ]
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "eventType",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "zoomLink",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "meetingId",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "passcode",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "smsEnabled",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "displayTime",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "leadFields",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "rsvpFormHeader",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "thankYouEmailHour",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "enableThankYouEmail",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "enableCancelEmail",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "enableInviteEmail",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "enableMorningReminderEmail",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "enableNightReminderEmail",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "enableRescheduleEmail",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "enableRsvpCancelledEmail",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "enableRsvpedEmail",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "enableWaitlistOpeningEmail",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "enableWaitlistedEmail",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "emailList",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "recurringEventType",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "repeatType",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "recurrenceType",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "recurrenceEndDate",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "recurringDaysList",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "getEventQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v7/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "getEventQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v7/*: any*/)
  },
  "params": {
    "operationKind": "query",
    "name": "getEventQuery",
    "id": null,
    "text": "query getEventQuery(\n  $id: ID!\n) {\n  hyevent(id: $id) {\n    approverName\n    inviteScheduledAt\n    approvedAt\n    disapprovedAt\n    id\n    title\n    maxNoOfGuests\n    additionalGuestAllowed\n    maxAdditionalGuests\n    ctaText\n    disapproveReason\n    messageTitle\n    message\n    address\n    placeName\n    status\n    propertyId\n    startAt\n    endAt\n    publishAt\n    cancelReason\n    rsvpedCount\n    landingPageHtml\n    invitedGroups\n    confirmPageHtml\n    confirmSmsBody\n    flyerHtml\n    waitlistedPageHtml\n    cancelRsvpPageHtml\n    removeFromWaitlistPageHtml\n    inviteEmailCampaignId\n    campaignTested\n    image {\n      id\n      fileType\n      fileSize\n      fileUrl\n      dimension\n      thumbnailUrl\n    }\n    document {\n      createdAt\n      dimension\n      fileSize\n      fileType\n      fileUrl\n      id\n      name\n      thumbnailUrl\n    }\n    eventType\n    zoomLink\n    meetingId\n    passcode\n    smsEnabled\n    displayTime\n    leadFields\n    rsvpFormHeader\n    thankYouEmailHour\n    enableThankYouEmail\n    enableCancelEmail\n    enableInviteEmail\n    enableMorningReminderEmail\n    enableNightReminderEmail\n    enableRescheduleEmail\n    enableRsvpCancelledEmail\n    enableRsvpedEmail\n    enableWaitlistOpeningEmail\n    enableWaitlistedEmail\n    emailList\n    recurringEventType\n    repeatType\n    recurrenceType\n    recurrenceEndDate\n    recurringDaysList\n    facebookShareUrl\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '66eb505a38adee8a65ca493733a1bdf5';
module.exports = node;
